/// <reference path="../../global/fn.js" />


;(function ($) {

    $.widget("nsp.organogrammaCarousel", {
        options: {
        },

        _create: function () {
            this.wrap = this.element;
            

            $(document).on("window-resized", ()=> {
                this.iniSlick();
            })

            this.iniSlick();
        },

        iniSlick: function () {
            var items = this.wrap.find('.s-organogramma__item').length;
         
            if (api.vars.windW < 1370) {          
                if (!this.wrap.hasClass('slick-initialized')) {
                    if(items > 1){
                        this.wrap.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: false,
                            infinite: false,
                            variableWidth: true                        
                        });
                    }else{
                        this.wrap.addClass('no-carousel')
                    }
                   
                }
            }         
             else {
                if (this.wrap.hasClass('slick-initialized')) {
                    this.wrap.slick('unslick');
                }
            }

        }     

    });
})(jQuery);